import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-screen-title',
  templateUrl: './screen-title.component.html',
  styleUrls: ['./screen-title.component.scss']
})
export class ScreenTitleComponent implements OnInit {

  @Input() title = '';
  @Input() iconClass = '';
  @Input() form: FormGroup;
  @Input() nomePropriedadeComplementoTitulo = 'nome'

  constructor() { }

  ngOnInit(): void {
  }

  public obterTituloComplementar() {
    let output = '';
    if (this.form) {
      const prop = this.form.get(this.nomePropriedadeComplementoTitulo);
      if (prop && prop.value) {
        output = ' - ' + prop.value;
      }
    }
    return output;
  }

}
